<template>
  <div class="faq-question" :class="classes" @click="isOpen = !isOpen">
    <div class="faq-question__toggle" :class="classes">
      <img src="@/assets/images/arrow-down.svg" />
    </div>
    <div class="faq-question__ask">{{ num }}. {{ ask }}</div>
    <transition name="fade">
      <div class="faq-question__answer" v-show="isOpen" v-html="answer" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "FaqQuestionItem",
  props: {
    num: {
      type: String,
      default: ""
    },
    ask: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    classes() {
      return {
        "--isOpen": this.isOpen
      };
    }
  },
  mounted() {
    if (this.num === "1") {
      this.isOpen = true;
    }
  }
};
</script>

<style lang="scss">
.faq-question {
  position: relative;
  padding: 2rem 6rem 2rem 3rem;
  margin-bottom: 3rem;
  border: 1px solid get($theme, "border");
  border-radius: get($radius, "arrounded");
  transition: all get($times, "long");
  @media #{$md-and-up} {
    cursor: pointer;
  }

  &__toggle {
    position: absolute;
    right: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    background: get($colors, "light-green");
    border-radius: 100%;
    color: get($theme, "secondary");
    @media #{$md-and-up} {
      cursor: pointer;
    }
    user-select: none;
    &.--isOpen {
      transform: rotate(180deg);
    }
    > img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &.--isOpen {
    border-color: get($theme, "secondary");
  }
  &__ask {
    // font-weight: bold;
    display: inline;
    color: get($theme, "secondary");
  }
  &__answer {
    margin-top: 2rem;
  }
}
</style>
